<script setup lang="ts">
import FooterBar from '@/components/footer-bar/FooterBar.vue'
import { ref } from 'vue'
import NicknameColor from './components/NicknameColor.vue'
import Consumables from './components/Consumables.vue'
import Gold from './components/Gold.vue'
import CrystalStore from './components/CrystalStore.vue'
import { useUserStore } from '@/stores/modules/user'
import { socketEmitAsync } from '@/utils/web-socket'
import { useCommonStore } from '@/stores/modules/common'

const commonStore = useCommonStore()
const userStore = useUserStore()

const curTab = ref('consumables')

function handleUseSponsorCdkey() {
  ElMessageBox.prompt('请输入赞赏卡密（使用回车区隔）【非兑换码】', '使用赞赏卡密', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    inputType: 'textarea',
    confirmButtonClass: 'is-plain',
    async beforeClose(action, instance, done) {
      if (action !== 'confirm') return done()
      try {
        instance.confirmButtonLoading = true
        instance.confirmButtonText = '加载中...'
        const value = instance.inputValue
        await socketEmitAsync({ type: 'useSponsorCdkey', data: { cdkeyList: value.split('\n') } })
        commonStore.getMailList()
        done()
      } finally {
        instance.confirmButtonLoading = false
        instance.confirmButtonText = '确定'
      }
    },
  })
}
</script>

<template>
  <div class="mall-page page">
    <h2>商城</h2>
    <el-tabs v-model="curTab" stretch>
      <el-tab-pane label="道具" name="consumables" class="pane" lazy>
        <Consumables />
      </el-tab-pane>
      <el-tab-pane label="金币" name="gold" class="pane" lazy>
        <Gold />
      </el-tab-pane>
      <el-tab-pane label="昵称颜色" name="nicknameColor" class="pane" lazy>
        <NicknameColor />
      </el-tab-pane>
      <el-tab-pane label="珍藏" name="crystalStore" class="pane" lazy v-if="userStore.vipLevel || userStore.crystal">
        <CrystalStore />
      </el-tab-pane>
    </el-tabs>
    <CommonBtn type="success" @done="handleUseSponsorCdkey" style="width: 100%; margin-top: 5px">使用赞赏卡密</CommonBtn>

    <FooterBar />
  </div>
</template>

<style lang="scss" scoped>
.mall-page {
  height: 100%;
  padding-top: 0;
  display: flex;
  flex-flow: column nowrap;
  .el-tabs {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-flow: column nowrap;
    :deep() {
      .el-tabs__content {
        flex: 1;
        .pane {
          height: 100%;
          .pane-item {
            height: 100%;
            overflow: hidden;
            display: flex;
            flex-flow: column nowrap;
          }
        }
      }
    }
  }
}
</style>
